export default __webpack_public_path__ + "static/media/icon-view.479d208a.svg";